module.exports = __webpack_public_path__ + "img/27.8506bc40.png";